import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/front/Main'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main,
      redirect: '/main'
    },
    {
      // home页面并不需要被访问，只是作为其它组件的父组件
      path: '/main',
      name: 'Main',
      component: Main,
      redirect: '/index',
      children: [
        {
          path: '/index',
          name: 'home',
          component: () => import('../components/front/home/Index')
        },
        {
          path: '/desc',
          name: 'desc',
          component: () => import('../components/front/desc/Index')
        },
        {
          path: '/product',
          name: 'product',
          component: () => import('../components/front/product/Index')
        },
        {
          path: '/partner',
          name: 'partner',
          component: () => import('../components/front/partner/Index')
        },
        {
          path: '/about',
          name: 'about',
          component: () => import('../components/front/about/Index')
        },
        {
          path: '/login',
          name: 'Login',
          component: () => import('../components/Login')
        },
        {
          path: '/register',
          name: 'Register',
          component: () => import('../components/Register')
        }
      ]
    },
    {
      path: '/admin',
      name: 'admin',
      component: () => import('../components/admin/Home'),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '*',
      component: () => import('../components/404/404')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js